import { Injectable } from '@angular/core';
import { ParticipantOffersUrlBuilderService } from '../../services/participant-offers-url-builder.service';
import { SignalRService } from './signalr.service';
import { DialogsService } from '../../services/dialog.service';
import { ServerLoggerService } from '../../services/server.service';
import {
  TargetFileFormingResultAppearedEventHandler
} from '../handlers/target-file-forming-result-appeared-event-handler';
import { LkAlertAppearedEventHandler } from '../handlers/lk-alert-appeared-event-handler';
import { PageRefreshRequiredEventHandler } from '../handlers/page-refresh-required-event-handler';
import { EventsService } from './events.service';
import {
  InvolvingProcessAndPowerOfAttorneyEventHandler
} from '../handlers/involving-process-and-power-of-attorney-event-handler';
import { LkLogoutRequiredEventHandler } from '../handlers/lk-logout-required-event-handler';
import { NotificationMpsService } from './notification-mps.service';
import { EventsNames } from '../enums/events-names.enum';

@Injectable({
  providedIn: 'root'
})
export class SupplierEventsService extends EventsService {
  // TODO 25.04.25 Литвиненко: перенести оставшиеся события из TP supplier-events
  constructor(
    urlBuilder: ParticipantOffersUrlBuilderService,
    signalRService: SignalRService,
    dialog: DialogsService,
    serverLogger: ServerLoggerService,
    targetFileFormingResultAppearedEventHandler: TargetFileFormingResultAppearedEventHandler,
    lkAlertAppearedEventHandler: LkAlertAppearedEventHandler,
    pageRefreshRequiredEventHandler: PageRefreshRequiredEventHandler,
    private _involvingProcessAndPowerAttorneyEventHandler: InvolvingProcessAndPowerOfAttorneyEventHandler,
    private _lkLogoutRequiredEventHandler: LkLogoutRequiredEventHandler,
    private _notificationMpsService: NotificationMpsService,
  ) {
    super(
      urlBuilder,
      signalRService,
      dialog,
      serverLogger,
      targetFileFormingResultAppearedEventHandler,
      lkAlertAppearedEventHandler,
      pageRefreshRequiredEventHandler,
    )
  }

  protected subscribeToEvents() {
    super.subscribeToEvents();

    this.subscribeToEvent(EventsNames.LkLogoutRequired, this._lkLogoutRequiredEventHandler);
    this.subscribeToEvent(
      EventsNames.InvolvingProcess,
      this._involvingProcessAndPowerAttorneyEventHandler
    );
    this.subscribeToEvent(
      EventsNames.PowerOfAttorney,
      this._involvingProcessAndPowerAttorneyEventHandler
    );
    this.subscribeToEvent(EventsNames.UserAlertsChanges, this._notificationMpsService);
  }
}
